export default "__VITE_ASSET__eiZgAtcX__"